import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { lockManagerApiRef, LockManagerClient } from './api';

export const lockManagerPlugin = createPlugin({
  id: 'lock-manager',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: lockManagerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new LockManagerClient({
          discoveryApi,
          fetchApi,
        }),
    }),
  ],
});

export const LockManagerPage = lockManagerPlugin.provide(
  createRoutableExtension({
    name: 'LockManagerPage',
    component: () =>
      import('./components/LockListComponent').then(m => m.LockListComponent),
    mountPoint: rootRouteRef,
  }),
);
